import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from 'react-redux';

import HasFeature from "src/utils/has-feature";
import HasRole from "src/utils/has-role";

import PlaybooksList from "./pages/list";
import PlaybookDetail from "./pages/detail";

import GroupContainer from "src/components/group-container";
import GroupMenu from "src/components/group-menu";

import { BookOpenIcon } from "@heroicons/react/24/outline";

const Layout = ({ children }) => {
  const items = [
    { name: 'Playbooks', description: "Automate workflows and processes with custom playbooks", icon: BookOpenIcon, path: '/playbooks', check: true },
    { name: 'Playbook', parent: 'Playbooks', description: 'View, edit, and manage a playbook', visible: false, path: '/playbooks/:id', check: true },
  ];
  
  return (
    <div id="content">
      <GroupMenu items={items} title="Bookings" />
      <GroupContainer>
        {children}
      </GroupContainer>
    </div>
  )
};

const Playbooks = () => {
  const { organisation: { features }, account: { account } } = useSelector((state) => state);

  if (account?.id) {
    const hasAccess = HasRole(account, ['developers:manage:keys', 'developers:manage:webhooks'], true) && HasFeature(features, ['developers', 'playbooks']);

    if (!hasAccess) {
      return <React.Fragment />;
    }

    return (
      <React.Fragment>
        <Route exact path="/playbooks" component={() => <Layout><PlaybooksList /></Layout>} />
        <Route exact path="/playbooks/:id" component={() => <Layout><PlaybookDetail /></Layout>} />
      </React.Fragment>
    );
  }

  return <React.Fragment />;
};

export default Playbooks;
